import script from "./TressTheMyPagesProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTheMyPagesProfile.vue?vue&type=script&lang=ts&setup=true"

import "./TressTheMyPagesProfile.vue?vue&type=style&index=0&id=6a3724e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3724e8"]])

export default __exports__